import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 text-2xl font-bold" }, "Customers", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_3 = { class: "w-1/4" }
const _hoisted_4 = { class: "w-1/4" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "text-xs" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Address 2: ")
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  style: {"font-style":"italic"}
}
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 5 }
const _hoisted_17 = { key: 6 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Details ")
const _hoisted_19 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_CustomerDetailDialog = _resolveComponent("CustomerDetailDialog")!
  const _component_EmailDialog = _resolveComponent("EmailDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _normalizeProps(_guardReactiveProps(_ctx.content)), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 24,
            class: "flex justify-between"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.openEmailDialog
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 24,
            class: "flex gap-1 mt-3"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_input, {
                  placeholder: "Search by name, email, phone, zip code, province",
                  modelValue: _ctx.params.search,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.search) = $event)),
                  maxlength: "400",
                  onKeypress: _withKeys(_ctx.fetchData, ["enter"])
                }, null, 8, ["modelValue", "onKeypress"])
              ]),
              _createVNode(_component_el_select, {
                placeholder: "Country",
                modelValue: _ctx.params.country,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.country) = $event)),
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id,
                      clearable: ""
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                placeholder: "Store",
                modelValue: _ctx.params.store,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.store) = $event)),
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (store) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: store.id,
                      label: store.appShopUrl,
                      value: store.id,
                      clearable: ""
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_input, {
                  placeholder: "Products purchased",
                  modelValue: _ctx.params.productPurchase,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.productPurchase) = $event)),
                  maxlength: "400",
                  onKeypress: _withKeys(_ctx.fetchData, ["enter"])
                }, null, 8, ["modelValue", "onKeypress"])
              ]),
              _createVNode(_component_el_input_number, {
                placeholder: "Order quantity",
                modelValue: _ctx.params.orderQuantity,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.orderQuantity) = $event)),
                "controls-position": "right"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_input_number, {
                placeholder: "Amount paid",
                modelValue: _ctx.params.amountPaid,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.params.amountPaid) = $event)),
                "controls-position": "right"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_table, {
                data: _ctx.documents,
                stripe: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      key: index,
                      label: column.title,
                      props: column.dataIndex,
                      "min-width": column.minWidth
                    }, {
                      default: _withCtx((scope) => [
                        (column.dataIndex == 'createdAt')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formatTime(scope.row[column.dataIndex])), 1))
                          : (column.dataIndex === 'email')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                _createElementVNode("p", _hoisted_7, _toDisplayString(scope.row[column.dataIndex]), 1),
                                (scope.row['phone'])
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Phone: " + _toDisplayString(scope.row['phone']), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (column.dataIndex == 'address')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                  _createElementVNode("p", null, _toDisplayString(scope.row['address1']), 1),
                                  (scope.row['address2']?.length > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                        _hoisted_11,
                                        _createElementVNode("i", null, _toDisplayString(scope.row['address2']), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (column.dataIndex == 'country')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                    (scope.row['countryCode'])
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(scope.row['countryCode']), 1))
                                      : _createCommentVNode("", true),
                                    (scope.row['country'])
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(scope.row['country']), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (column.dataIndex == 'sellerTeam')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row[column.dataIndex]?.name
                      ? scope.row[column.dataIndex]?.name
                      : scope.row[column.dataIndex]?.code), 1))
                                  : (column.dataIndex === 'customerValue')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.formatterDollars(scope.row[column.dataIndex])), 1))
                                    : (column.dataIndex == 'action')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                          _createVNode(_component_el_button, {
                                            type: "text",
                                            title: "Edit",
                                            onClick: ($event: any) => (_ctx.onViewDetailCustomer(scope.row['email']))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_18
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(scope.row[column.dataIndex]), 1))
                      ]),
                      _: 2
                    }, 1032, ["label", "props", "min-width"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data"]), [
                [_directive_loading, _ctx.isLoading]
              ]),
              _createVNode(_component_pagination, {
                total: _ctx.total,
                pagination: _ctx.params.page,
                "onUpdate:pagination": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.params.page) = $event)),
                limit: _ctx.params.limit,
                "onUpdate:limit": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.params.limit) = $event))
              }, null, 8, ["total", "pagination", "limit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CustomerDetailDialog, { ref: "customerDetailDialog" }, null, 512),
      _createVNode(_component_EmailDialog, {
        ref: "emailDialog",
        onSuccess: _ctx.successNoti,
        onFail: _ctx.failNoti
      }, null, 8, ["onSuccess", "onFail"])
    ]),
    _: 1
  }, 16))
}